export const getQueryParams = ({ request }, keys) => {
	const [_, searchParams] = request.url.split('?');
	const params = new URLSearchParams(searchParams);
	const result = {};

	keys.forEach((key) => {
		result[key] = params.get(key);
	});

	return result;
};
